import React, {FC} from "react";
import './InfoContainer.css';

interface InfoContainerProps {
    logoDark: string;
    logoWhite: string;
    title: string;
    description: string;
    redirectLink: string;
    isActive: boolean;
}

const InfoContainer:FC<InfoContainerProps> = ({logoDark, logoWhite, title, description, redirectLink, isActive}) => {
    return(
        <div className={`info-container ${isActive ? 'active' : ''}`}>
            <div className="info-logo">
                <img src={isActive ? logoWhite : logoDark} alt="Logo" />
            </div>
            <h2 className="info-title">{title}</h2>
            <p className="info-description">{description}</p>
            <button className="learn-more-btn">{redirectLink}</button>
        </div>
    )
}

export default InfoContainer;